import $ from 'jquery/src/jquery';
import { tns } from 'tiny-slider';
import 'tiny-slider/src/tiny-slider.scss';

$(document).ready(function($) {
    $('.homeSlider').each(function(index, element) {
        const $carousel = $(element);
        const $container = $carousel.find('[class*="__slides"]');
        const $slides = $carousel.find('.homeSlider__slide');
        const defaultDelay = 3000;
        const slider = tns({
            container: $container[0],
            loop: true,
            gutter: 0,
            autoplay: true,
            autoplayButtonOutput: false,
            autoplayHoverPause: true,
            autoplayTimeout: defaultDelay,
            nav: true,
            navPosition: 'bottom',
            navContainer: $carousel.find('.homeSlider__nav')[0],
            controls: false,
            autoHeight: false,
            mouseDrag: true,
        });
        slider.events.on('dragStart', function() {
            slider.pause();
        });
        slider.events.on('dragMove', function() {
            slider.pause();
        });
        slider.events.on('dragEnd', function() {
            slider.pause();
        });
        slider.pause();
        setTimeout(() => {
            slider.play();
        }, Math.abs(parseInt($slides[0].dataset.delay)*1000 - defaultDelay));
        slider.events.on('indexChanged', () => {
            const info = slider.getInfo();
            const nextDelay = parseInt($slides[info.displayIndex-1].dataset.delay ?? 0)*1000 || defaultDelay;
            slider.pause();
            setTimeout(() => {
                slider.play();
            }, Math.abs(defaultDelay - nextDelay));
        });
    })
});